<template>
<section class="hero">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        毛糸玉（けいとだま）のサイトにようこそ
      </h1>
      <h2 class="subtitle">
        Welcome to Keitodama site. <br>
        （Spoonラジオの公式CMに勝手に採用されてました）<br>        
        <youtube class="youtubeVideo"
        ref="youtube"
        :video-id="videoId"
        :player-vars="{autoplay:no}"
        @playing="playung"
        @paused="paused"
        @ended="ended"
        /><br />
        Youtubeに<a href="https://www.youtube.com/channel/UCGMg0X_5e5eOHIOSTjXG1JA/" target="_blank">丸ット団</a>というチャンネル名で毛糸として活動し動画を上げています。<br>
        Mirrativでも<a href="https://www.mirrativ.com/user/8053721" target="_blank">毛糸</a>というユーザー名で活動を開始しました。<br>
      </h2>
      <h3>
        <div class="iframely-embed">
          <div class="iframely-responsive" style="height: 140px; padding-bottom: 0; float: left;">
            <a href="https://www.mirrativ.com/user/8053721" data-iframely-url="//cdn.iframe.ly/ooHsgFX"></a>
          </div>
          <div class="iframely-responsive" style="height: 140px; padding-bottom: 0; float: right;">
            <a href="https://www.youtube.com/channel/UCGMg0X_5e5eOHIOSTjXG1JA" data-iframely-url="//cdn.iframe.ly/5WIGQvq"></a>
          </div>
        </div>
      </h3>
    </div>
  </div>

  <div class="container">
    <h1 class="title">
      毛糸玉のTwitter
      <a href="https://twitter.com/keitodama0?ref_src=twsrc%5Etfw" class="twitter-follow-button" data-size="large" data-lang="ja" data-show-count="false">Follow @keitodama0</a>
    </h1>
    <h2 class="subtitle">
      <twitter>
      <div slot="loading">loading...</div>
      <a class="twitter-timeline" data-width="500" data-height="600" data-lang="ja" href="https://twitter.com/keitodama0?ref_src=twsrc%5Etfw">Tweets by keitodama0</a>
      </twitter>
      </h2>
    </div>
  </section>
</template>
<script>
import { twitter } from 'vue-twitter'

export default {
  components: {
    twitter
  },
  /* eslint-disable */
  data (){
    return {
      videoId: 'oIS18IQdzts',
    }
  },

  methods: {
    playVideo() {
      this.player.playVideo()
    },

    playing() {
      console.log('Video Play')
    },

    paused(){
      console.log('Paused')
      },

    ended() {
      console.log('Play end')
    }
  }
}
</script>
<style>

.youtubeVideo {
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue